import { ConnectDropTarget } from 'react-dnd';

import { IPill } from 'partsOld/types';

import { AlignLeft, Wrapper } from './dragAndDropStyle';
import Pill from '../Pill';

interface IProps {
  item: string;
  drop: ConnectDropTarget;
  isOver: boolean;
  pill: IPill;
  addNewHeader: boolean;
}

const DragAndDropHeaderView = ({ item, drop, isOver, pill, addNewHeader }: IProps) => {
  const title = addNewHeader ? '' : item;

  return (
    <Wrapper ref={drop} isOver={isOver}>
      <AlignLeft>{pill ? <Pill pill={pill} showCloseIcon /> : title}</AlignLeft>
    </Wrapper>
  );
};

export default DragAndDropHeaderView;
